import { FIRST_SYMBOL_$ } from '@common';

export function currencyInvert(value: string): string {
  const withoutSymbol = value.replace(FIRST_SYMBOL_$, '');
  return String(+withoutSymbol * 100);
}
